import { render, staticRenderFns } from "./FormMasterDataStaff.vue?vue&type=template&id=4dfa97f0&scoped=true"
import script from "./FormMasterDataStaff.vue?vue&type=script&lang=js"
export * from "./FormMasterDataStaff.vue?vue&type=script&lang=js"
import style0 from "./FormMasterDataStaff.vue?vue&type=style&index=0&id=4dfa97f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa97f0",
  null
  
)

export default component.exports